module.exports = __webpack_public_path__ + "img/min-min-min.b678e940.png";